import { EMPTY_STRING } from '../../../constants/common'

export const CONNECTED_REQUESTS_MASS_EDIT_MODAL_QA_NAME =
  'connectedRequestsMassEditModal'

export const CONNECTED_REQUESTS_MASS_EDIT_MODAL_FORM_QA_NAME =
  'connectedRequestsMassEditModalForm'

export const CONNECTED_REQUESTS_MASS_EDIT_FORM_FIELD_NAMES = {
  excludeArchived: 'exclude_archived',
  parameters: 'parameters',
}

export const CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES = {
  action: 'action',
  comment: 'comment',
  field: 'field',
  isComment: 'isComment',
  rowId: 'rowId',
  template: 'template',
  value: 'value',
}

export const CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_ROW_ID_PREFIX =
  'parameterRow_'

export const CONNECTED_REQUESTS_MASS_EDIT_FIELDS = {
  category: 'category',
  deadline: 'due_date',
  labels: 'labels',
  managers: 'assignees',
  providers: 'contractors',
  status: 'status',
  visibility: 'visible_to_dwellers',
}

export const CONNECTED_REQUESTS_MASS_EDIT_ACTIONS = {
  add: 'add',
  delete: 'clear',
  edit: 'set',
  findAndRemove: 'find_and_remove',
}

export const CONNECTED_REQUESTS_MASS_EDIT_ACTION_OPTION_LABELS = {
  [CONNECTED_REQUESTS_MASS_EDIT_ACTIONS.add]:
    'ConnectedRequestsMassEdit.ActionAddOptionKey',
  [CONNECTED_REQUESTS_MASS_EDIT_ACTIONS.delete]:
    'ConnectedRequestsMassEdit.ActionDeleteOptionKey',
  [CONNECTED_REQUESTS_MASS_EDIT_ACTIONS.edit]:
    'ConnectedRequestsMassEdit.ActionEditOptionKey',
  [CONNECTED_REQUESTS_MASS_EDIT_ACTIONS.findAndRemove]:
    'ConnectedRequestsMassEdit.ActionFindAndRemoveOptionKey',
}

export const CONNECTED_REQUESTS_MASS_EDIT_VISIBILITY_OPTIONS = [
  {
    label: 'ConnectedRequestsMassEdit.PrivateVisibilityOptionKey',
    value: false,
  },
  {
    label: 'ConnectedRequestsMassEdit.PublicVisibilityOptionKey',
    value: true,
  },
]

export const CONNECTED_REQUESTS_MASS_EDIT_FIELD_OPTION_LABEL_KEYS = {
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.category]:
    'ConnectedRequestsMassEdit.FieldCategoryOptionKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.deadline]:
    'ConnectedRequestsMassEdit.FieldDeadlineOptionKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.labels]:
    'ConnectedRequestsMassEdit.FieldLabelsOptionKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.managers]:
    'ConnectedRequestsMassEdit.FieldManagersOptionKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.providers]:
    'ConnectedRequestsMassEdit.FieldProvidersOptionKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.status]:
    'ConnectedRequestsMassEdit.FieldStatusOptionKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.visibility]:
    'ConnectedRequestsMassEdit.FieldVisibilityOptionKey',
}

export const CONNECTED_REQUESTS_MASS_EDIT_VALUE_LABEL_KEYS = {
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.category]:
    'ConnectedRequestsMassEdit.CategoryValueLabelKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.labels]:
    'ConnectedRequestsMassEdit.LabelsValueLabelKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.managers]:
    'ConnectedRequestsMassEdit.ManagersValueLabelKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.providers]:
    'ConnectedRequestsMassEdit.ProvidersValueLabelKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.status]:
    'ConnectedRequestsMassEdit.StatusValueLabelKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.visibility]:
    'ConnectedRequestsMassEdit.VisibilityValueLabelKey',
  default: 'ConnectedRequestsMassEdit.ValueLabelKey',
}

export const CONNECTED_REQUESTS_MASS_EDIT_VALUE_PLACEHOLDER_KEYS = {
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.category]:
    'ConnectedRequestsMassEdit.CategoryValuePlaceholderKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.labels]:
    'ConnectedRequestsMassEdit.LabelsValuePlaceholderKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.managers]:
    'ConnectedRequestsMassEdit.ManagersValuePlaceholderKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.providers]:
    'ConnectedRequestsMassEdit.ProvidersValuePlaceholderKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.status]:
    'ConnectedRequestsMassEdit.StatusValuePlaceholderKey',
  [CONNECTED_REQUESTS_MASS_EDIT_FIELDS.visibility]:
    'ConnectedRequestsMassEdit.VisibilityValuePlaceholderKey',
}

export const CONNECTED_REQUESTS_MASS_EDIT_EMPTY_PARAMETER = {
  [CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.action]: null,
  [CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.comment]: EMPTY_STRING,
  [CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.field]: null,
  [CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.isComment]: false,
  [CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.template]: EMPTY_STRING,
  [CONNECTED_REQUESTS_MASS_EDIT_PARAMETER_FIELD_NAMES.value]: null,
}

export function getConnectedRequestsMassEditInitialValues() {
  return {
    [CONNECTED_REQUESTS_MASS_EDIT_FORM_FIELD_NAMES.excludeArchived]: false,
    [CONNECTED_REQUESTS_MASS_EDIT_FORM_FIELD_NAMES.parameters]: [
      {
        ...CONNECTED_REQUESTS_MASS_EDIT_EMPTY_PARAMETER,
      },
    ],
  }
}

export const QA_NAME_ADD_PARAMETER_BUTTON =
  'connectedRequestsMassEditAddParameterButton'

export const QA_NAME_DELETE_PARAMETER_BUTTON =
  'connectedRequestsMassEditDeleteParameterButton'

export const QA_NAME_SEND_NOTIFICATION_CHECKBOX =
  'connectedRequestsMassEditSendNotificationCheckbox'

export const QA_NAME_VIEW_COMMENT_BUTTON =
  'connectedRequestsMassEditViewCommentButton'
